<template>
	<div v-if="myCustomer?.id === 4">
		<div
			class="mx-auto mb-4 mt-4 w-[85%] w-full rounded-md border-[1px] border-b-gray-200"
		/>

		<div class="mt-2 flex flex-row gap-2">
			<div class="flex-1">
				<sg-input
					v-model="desiredSpacing"
					label="Desired Spacing"
					type="number"
					step="0.01"
					min="0"
					max="10000"
				/>
			</div>
			<div class="flex-1">
				<sg-input
					v-model="bedCount"
					label="Bed Count"
					type="number"
					step="1"
					min="0"
					max="10000"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
	import { useMyCustomer } from "seedgreen-shared/queries/customer";
	import { ref, computed, watch } from "vue";
	import SgInput from "@/components/ui/SgInput.vue";
	import type { BonipakThinFieldData } from "seedgreen-shared/dtos/TaskRequestDTO";
	import { usePlanting } from "seedgreen-shared/queries/planting";

	const modelData = defineModel<BonipakThinFieldData>();

	const props = defineProps<{
		selectedPlantingId?: number;
	}>();

	// Fetch the selected planting data
	const selectedPlantingIdRef = computed(() => props.selectedPlantingId);
	const { planting: selectedPlanting } = usePlanting(selectedPlantingIdRef);

	const desiredSpacing = ref<string>(
		modelData.value?.desiredSpacing?.toString() || "",
	);

	const bedCount = ref<string>(modelData.value?.bedCount?.toString() || "");

	// Computed property to build the complete BonipakThinFieldData object
	const formDataObject = computed<BonipakThinFieldData>(() => ({
		desiredSpacing: desiredSpacing.value
			? parseFloat(desiredSpacing.value)
			: undefined,
		bedCount: bedCount.value ? parseInt(bedCount.value) : undefined,
	}));

	// Watch for changes and update the model
	watch(
		formDataObject,
		(newValue) => {
			modelData.value = newValue;
		},
		{ deep: true, immediate: true },
	);

	// Watch for changes to the selected planting and autofill form fields
	watch(
		selectedPlanting,
		(newPlanting) => {
			if (newPlanting) {
				// Autofill from planting data
				if (newPlanting.plantSpacingInchesCurrent !== undefined) {
					desiredSpacing.value =
						newPlanting.plantSpacingInchesCurrent.toString();
				}
				if (newPlanting.bedCountCurrent !== undefined) {
					bedCount.value = newPlanting.bedCountCurrent.toString();
				}
			}
		},
		{ immediate: true },
	);

	const { myCustomer } = useMyCustomer();
</script>
